import IconChevronRightLarge from '@picsart/icons/IconChevronRightLarge';
import cls from 'classnames';

import { StepProps } from './types';
import useStyles from './stepStyles';

function Step({
  className,
  index,
  title,
  description,
  Element = 'h3',
  isSelected,
  hasArrow,
  onClick,
}: StepProps) {
  const classes = useStyles();

  return (
    <div
      onClick={onClick}
      className={cls('flex', classes.root, isSelected && classes.selected, className)}
    >
      <div>
        <div className={cls('flex', 'align-center', classes.container)}>
          <div className={cls('fs-20', classes.index)}>
            <span>{index}</span>
          </div>
          <div>
            <Element className={cls('fs-16', classes.title)}>{title}</Element>
            <p className={classes.description}>{description}</p>
          </div>
          {hasArrow && <IconChevronRightLarge className={classes.icon} />}
        </div>
      </div>
    </div>
  );
}

export default Step;
